import { Befehl3 } from '../../../models'
import {
  BefehlAuftrag_3_10Dto,
  BefehlAuftrag_3_15Dto,
  BefehlAuftrag_3_20Dto
} from '../../../dtos'
import { Befehl3FormData, Befehl3FormSchema } from './schema'
import { createSimpleAuftrag, hasAuftrag } from '../converter-utils'
import { Befehl3DataDto } from '../../../dtos/befehl-3-dto'

export const convertModelToBefehl3FormData = (
  befehl?: Befehl3
): Befehl3FormData => {
  const formData = Befehl3FormSchema.parse({})

  if (!befehl) {
    return formData
  }

  // If model exists but has empty auftraege, disable all except 3.10 which is not user changeable
  if (befehl.auftraege?.length === 0) {
    formData.auftrag_3_15.enabled = false
    formData.auftrag_3_20.enabled = false
    return formData
  }

  if (!befehl.auftraege) {
    return formData
  }

  // auftrag_3_10 enabled not changeable by user
  if (hasAuftrag(befehl.auftraege, '3.10')) {
    formData.auftrag_3_10.enabled = true
  }

  formData.auftrag_3_15.enabled = hasAuftrag(befehl.auftraege, '3.15')
  formData.auftrag_3_20.enabled = hasAuftrag(befehl.auftraege, '3.20')

  return formData
}

export const convertBefehl3FormDataToModel = (
  formData: Befehl3FormData,
  frontendId: string
): Befehl3 => {
  const auftraege: Befehl3DataDto = []

  const auftrag310 = createSimpleAuftrag('3.10', formData.auftrag_3_10?.enabled)
  if (auftrag310) {
    auftraege.push(auftrag310 as BefehlAuftrag_3_10Dto)
  }

  const auftrag315 = createSimpleAuftrag('3.15', formData.auftrag_3_15?.enabled)
  if (auftrag315) {
    auftraege.push(auftrag315 as BefehlAuftrag_3_15Dto)
  }

  const auftrag320 = createSimpleAuftrag('3.20', formData.auftrag_3_20?.enabled)
  if (auftrag320) {
    auftraege.push(auftrag320 as BefehlAuftrag_3_20Dto)
  }

  return {
    kennung: '3',
    frontendId,
    auftraege
  }
}
